var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidayIconActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.880859,
    width: 32,
    height: 31.4386,
    rx: 15.7193,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8805 9.05273C13.2005 9.05273 10.2139 12.0394 10.2139 15.7194C10.2139 19.3994 13.2005 22.3861 16.8805 22.3861C20.5605 22.3861 23.5472 19.3994 23.5472 15.7194C23.5472 12.0394 20.5605 9.05273 16.8805 9.05273ZM16.8805 21.0527C13.9405 21.0527 11.5472 18.6594 11.5472 15.7194C11.5472 12.7794 13.9405 10.3861 16.8805 10.3861C19.8205 10.3861 22.2139 12.7794 22.2139 15.7194C22.2139 18.6594 19.8205 21.0527 16.8805 21.0527ZM16.8805 11.7194C14.6805 11.7194 12.8805 13.5194 12.8805 15.7194C12.8805 17.9194 14.6805 19.7194 16.8805 19.7194C19.0805 19.7194 20.8805 17.9194 20.8805 15.7194C20.8805 13.5194 19.1472 11.7194 16.8805 11.7194ZM18.8805 16.3861H14.8805V15.0527H18.8805V16.3861Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayIconActivate);
export default __webpack_public_path__ + "static/media/holidayIconActivate.3bdf2fb6c040d521439cadd42901b51f.svg";
export { ForwardRef as ReactComponent };